import React from 'react'
import { unsubscribedEmail } from '../../api/actions/unsubscibed';
import { LOGIN } from '../../constants/pathname';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const Unsubscribed = () => {

    const navigate = useNavigate()
    const handleConfirm = () => {

        const urlParams = new URLSearchParams(window.location.search);
        const uid = urlParams.get('uid');
        const token = urlParams.get('token');
        const club = urlParams.get('club')


        const payload = {
            uid: uid,
            token: token,
            club: Number(club),

            email_subscription_status: false
        };


        unsubscribedEmail(payload)((response) => {
            console.log('API Response:', response);
            if (response.status_code === 200) {
                toast.success(response?.message || 'Successfully unsubscribed!');
            } else {
                toast.error(response?.message || 'Something went wrong. Please try again.');
            }
        });
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
        }}>
            <div style={{
                maxWidth: '400px',
                width: '100%',
                margin: '0 auto',
                padding: '40px 30px',
                textAlign: 'center',
                borderRadius: '20px',
                fontFamily: 'Arial, sans-serif',
                background: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',

            }}
            >

                {/* Icon */}
                <div style={{
                    width: '80px',
                    height: '80px',
                    margin: '0 auto 30px',
                    background: 'var(--sandy-brown)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 10px 30px rgba(238, 90, 36, 0.3)'
                }}>
                    <span style={{ fontSize: '36px', color: 'white' }}>✉️</span>
                </div>

                {/* Content */}
                <p style={{
                    color: '#333',
                    marginBottom: '10px',
                    fontSize: '20px',
                    fontWeight: '600',
                    lineHeight: '1.5'
                }}>
                    Sorry to see you go!
                </p>

                <p style={{
                    color: '#555',
                    marginBottom: '40px',
                    fontSize: '18px',
                    fontWeight: '500',
                    lineHeight: '1.5'
                }}>
                    You have been unsubscribed from our mailing list.
                </p>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '15px',
                    flexWrap: 'wrap'
                }}>
                    <button
                        onClick={handleConfirm}
                        style={{
                            backgroundColor: '#28a745',
                            color: 'white',
                            border: '1px solid #28a745',
                            padding: '12px 24px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: '500',
                            minWidth: '100px',
                            outline: 'none',
                            transition: 'all 0.2s ease'
                        }}

                    >
                        Confirm
                    </button>

                    <button
                        onClick={() => navigate(LOGIN)}
                        style={{
                            backgroundColor: '#6c757d',
                            color: 'white',
                            border: '1px solid #6c757d',
                            padding: '12px 24px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: '500',
                            minWidth: '100px',
                            outline: 'none',
                            transition: 'all 0.2s ease'
                        }}

                    >
                        Go Back
                    </button>
                </div>



            </div>

            {/* Mobile responsive styles */}
            <style jsx>{`
        @media (max-width: 768px) {
          div[style*="maxWidth: '400px'"] {
            padding: 30px 20px !important;
            margin: 20px !important;
          }
        }
        
        @media (max-width: 480px) {
          div[style*="fontSize: '20px'"] {
            font-size: 18px !important;
          }
          
          div[style*="fontSize: '18px'"] {
            font-size: 16px !important;
          }
          
          button[style*="fontSize: '18px'"] {
            font-size: 16px !important;
            padding: 12px 30px !important;
          }
        }
      `}</style>
        </div>
    )
}

export default Unsubscribed